// 弹窗的默认配置
export const defaultValue = {
  overlay: true,
  title: '',
  message: '',
  width: '75%',
  zIndex: 2000,
  borderRadius: 8,
  showConfirmButton: true,
  showCancelButton: true,
  confirmText: '确认',
  cancelText: '取消',
  confirmColor: 'var(--primary-color)',
  cancelColor: 'var(--font-color_1)'
}